export const remToPixel = (breakpoints: any[]) => {
  return breakpoints.map((breakpoint) => parseInt(breakpoint) * 16);
};
